module.exports = __webpack_public_path__ + "static/pic02-3f8e94e773cec869d6bda841a2e9c580.jpg";